<template lang="pug">
  #ChallengeOverview
    .level.is-mobile(v-if="!challenge.isPreventative")
      .level-left
        .level-item
          WtTitle(card-title) Challenge Overview
      .level-right
        .level-item
          ChallengeForfeitActionMenu(v-if="! challenge.isPvsPChallenge && isJoined" :challenge="challenge")
    figure.is-pulled-right(v-if="!challenge.isPreventative")
      p.image.is-64x64
        img.is-rounded(:src="_.get(challenge, 'map.image', null)" alt="")
    .content(v-if="!challenge.isPreventative")
      p
        span.has-text-weight-semibold Type:&nbsp
        span {{ challengeType(challenge) }} Challenge
      p(v-if="_.get(challenge, 'isPvsPChallenge', '')")
        span.is-family-secondary.pr-2 About PvsP Challenges:
        span
          | This challenge pairs your program with others. Data is updated once per hour and
          |  is tallied by taking the cumulative daily average of all active members of the opposing programs.
      p(v-if="! challenge.isPvsPChallenge")
        span.has-text-weight-semibold Created by:&nbsp
        RouterLink(
          v-if="_.get(challenge, 'initiator.username', false)"
          :to="`/profile/${challenge.initiator.username}`"
        ) @{{ challenge.initiator.username }}
      p
        span.has-text-weight-semibold Start Date:&nbsp
        span {{ challenge.startDate ? date(challenge.startDate, "DATE_FORMAT_SHORT_MONTH").formatted : '' }}
      p
        span.has-text-weight-semibold End Date:&nbsp
        span {{ challenge.endDate ? date(challenge.endDate, "DATE_FORMAT_SHORT_MONTH").formatted : '' }}
      p
        span.has-text-weight-semibold What's Being Counted:&nbsp
        span {{ _.get(challenge, 'stepsOrActivitiesText', '') }}
      p(v-if="_.get(challenge, 'atStake', '')")
        span.has-text-weight-semibold Challenge Details:&nbsp
        WtDisplayRichTextHTML.pb-4(:html="challenge.atStake")
    .content(v-if="challenge.isPreventative")
      p
        span.has-text-weight-bold Challenge
        br
        span.has-text-grey Preventative Challenge
      p
        span.has-text-weight-bold Type
        br
        span.has-text-grey {{challenge.name}}
      p
        span.has-text-weight-bold Challenge Details
        br
        WtDisplayRichTextHTML(:html="challenge.atStake")
      p
        span.has-text-weight-bold Points
        br
        span.has-text-grey {{pointsAwardedForChallenge}}
      p
        span.has-text-weight-bold Start Date
        br
        span.has-text-grey {{ challenge.startDate ? date(challenge.startDate, "DATE_FORMAT_SHORT_MONTH").formatted : '' }}
      p
        span.has-text-weight-bold End Date
        br
        span.has-text-grey {{ challenge.endDate ? date(challenge.endDate, "DATE_FORMAT_SHORT_MONTH").formatted : '' }}
      p
        span.has-text-weight-bold Created by
        br
        RouterLink(
          v-if="_.get(challenge, 'initiator.username', false)"
          :to="`/profile/${challenge.initiator.username}`"
        ) @{{ challenge.initiator.username }}
</template>

<script>
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import ChallengeForfeitActionMenu from "@@/Challenge/ChallengeForfeitActionMenu";

export default {
  name: "ChallengeOverview",

  components: {
    WtActionMenu,
    WtButton,
    WtDisplayRichTextHTML,
    WtTitle,
    ChallengeForfeitActionMenu
  },

  mixins: [dateUtilityMixin, challengeMixin],

  props: {
    challenge: {
      type: Object,
      default: () => {
        return {
          id: null,
          initiator: {
            username: null
          },
          map: {
            image: null,
            details: null
          },
          startDate: null,
          endDate: null,
          stepsOrActivitiesText: null,
          teams: null
        };
      }
    }
  },

  computed: {
    ...mapGetters(["members/challenges"]),

    isJoined() {
      const isTeamChallenge =
        this._.get(this.challenge, "between", "") === "groups";

      if (isTeamChallenge) {
        return this.challenge.teams.some(team =>
          this._.get(team, "isAdmin", false)
        );
      } else {
        const memberChallengeIds = this["members/challenges"].map(
          item => item.id
        );
        return memberChallengeIds.includes(this.challenge.id);
      }
    },
    pointsAwardedForChallenge() {
      if (this.challenge.incentivesOn) {
        return this.challenge.incentivesAmount;
      }
      return "No points awarded for completing this challenge";
    }
  }
};
</script>

<style lang="sass" scoped>
#ChallengeOverview
  .has-text-weight-bold
    font-family: $family-sans-serif-bold
</style>
